import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { StringHelpers } from 'e4shared';
import { useSelector } from 'react-redux';
import { e4Format, e4Formats } from 'helpers/dates';

export const Overtime = ({ data, metric }) => {
    const currencySymbol = useSelector(state => state.user.user?.currencySymbol);
    const setData = [{ id: 'Overtime', data: data.map(p => ({ x: new Date(p.date_Set), y: Number(p.value) })) }];

    const maxY = Math.max(...setData[0].data.map(d => d.y));

    const estimateLabelWidth = value => {
        const label = StringHelpers.formatMetric(metric.format, value, currencySymbol); // match axis formatter
        return label.length * 7 + 10; // ~7px per char + padding
    };

    const leftMargin = estimateLabelWidth(maxY);

    const points = setData[0].data;
    const maxTicks = 5;

    const tickValues =
        points.length <= maxTicks
            ? points.map(d => d.x)
            : points.filter((_, i) => i % Math.ceil(points.length / maxTicks) === 0).map(d => d.x);

    return (
        <ResponsiveLine
            data={setData}
            margin={{ top: 10, right: 10, bottom: 25, left: leftMargin }}
            xScale={{
                type: 'time',
                useUTC: false,
                precision: 'day',
                min: 'auto',
                max: 'auto',
            }}
            yScale={{ type: 'linear', min: 'auto', max: 'auto' }}
            curve="monotoneX"
            theme={{
                axis: {
                    domain: {
                        line: {
                            stroke: 'rgba(0,0,0,0.6)',
                            strokeWidth: 1,
                        },
                    },
                    ticks: {
                        line: {
                            stroke: 'transparent', // keep tick marks hidden
                        },
                        text: {
                            fill: 'rgba(0,0,0,0.6)',
                        },
                    },
                },
            }}
            axisBottom={{
                format: v => e4Format(v instanceof Date ? v : new Date(v), e4Formats.monthShort),
                tickSize: 0,
                tickValues,
                tickPadding: 8,
            }}
            axisLeft={{
                tickSize: 0,
                tickPadding: 8,
                tickRotation: 0,
                legendOffset: -50,
                legendPosition: 'middle',
                format: v => StringHelpers.formatMetric(metric.format, v, currencySymbol),
            }}
            enableGridY={false}
            enableGridX={false}
            lineWidth={1.2}
            enableArea
            areaOpacity={0.2}
            areaBaselineValue={0}
            areaBlendMode="normal"
            areaColors={['#FFB86B']}
            colors={['#FFB86B']}
            pointSize={8}
            pointColor="#FFB86B"
            pointBorderWidth={0}
            pointLabelYOffset={-12}
            useMesh
            tooltip={({ point }) => {
                const date = point.data.x instanceof Date ? point.data.x : new Date(point.data.x);

                return (
                    <div
                        style={{
                            padding: '6px 10px',
                            background: 'white',
                            border: '1px solid #ccc',
                            fontSize: 12,
                        }}
                    >
                        <strong>
                            {e4Format(date, 'MMM yy')}: {point.data.y}
                        </strong>
                    </div>
                );
            }}
        />
    );
};
